<template>
  <div>
    <div class="title-popup-s ">{{ title }}</div>
    <el-select :disabled="disabled" class="time" v-model="hour" placeholder="시" :style="{width: width > 0 ? width+'px' : null}">
      <el-option class="ie-select" v-for="time in TIME" :key="time.time" :label="time.label" :value="time.time" />
    </el-select>
    <span>시</span>
    <el-select :disabled="disabled" class="time" v-model="minute" placeholder="분" :style="{width: width > 0 ? width+'px' : null}">
      <el-option class="ie-select" v-for="min in MINUTE" :key="min.minute" :label="min.label" :value="min.minute" />
    </el-select>
    <span>분</span>
  </div>
</template>

<script>
import { TIME, MINUTE } from '@/constants/date';

export default {
  name: 'WTimeSelectionComponent',
  props: {
    title: String,
    executeHour: Number,
    executeMinute: Number,
    width: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TIME,
      MINUTE,
      hour: 0,
      minute: 0,
    };
  },
  watch: {
    executeHour(hour) {
      this.hour = hour;
    },
    executeMinute(minute) {
      this.minute = minute;
    },
  },
  methods: {
    init() {
      this.hour = 0;
      this.minute = 0;
    },
    getSelectionTime() {
      return {
        hour: this.hour,
        minute: this.minute,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.time {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/components/TimeSelectionComponent.vue